module.exports = __webpack_public_path__ + "assets/01.119b2d0a.pdf";